import React from 'react';
import pt from 'prop-types';

import FeatureGate from 'app/launch-darkly/gates/feature-gate';
import { FEATURE_FLAGS } from 'app/launch-darkly/featureFlags';

import { IdentitySyncFieldsTable, ConsentCategoryTable } from './index';
import BringYourOwnSyncFieldsTable from './BringYourOwnSyncFieldsTable';
import { BRING_YOUR_OWN_SYNCS, CUSTOM_IDENTITY_SYNC } from './consts';
import CustomIdentitySyncTable from './CustomIdentitySyncTable';
import TcfConsentTable from 'app/components/analytics-builder/identity-sync-card/components/TcfConsentTable';
import ResyncToggle from 'app/components/analytics-builder/identity-sync-card/components/ResyncToggle';

const CardBody = ({
  fields,
  resetError,
  formState,
  setField,
  syncName,
  syncFriendlyName,
  validateField,
  validateNumber,
  validateRequired,
}) => {
  return (
    <>
      {syncName !== CUSTOM_IDENTITY_SYNC.REQUEST_NAME && (
        <FeatureGate flagName={FEATURE_FLAGS.configurableConsentMvp}>
          <ConsentCategoryTable
            resetError={resetError}
            formState={formState}
            setField={setField}
            syncName={syncName}
            validateField={validateField}
            validateRequired={validateRequired}
            validateNumber={validateNumber}
          />
          <TcfConsentTable
            formState={formState}
            setField={setField}
            syncName={syncName}
            validateRequired={validateRequired}
            validateField={validateRequired}
          />
        </FeatureGate>
      )}
      <SyncType
        fields={fields}
        setField={setField}
        resetError={resetError}
        formState={formState}
        syncName={syncName}
        validateField={validateField}
        validateRequired={validateRequired}
        validateNumber={validateNumber}
      />
      {syncName !== CUSTOM_IDENTITY_SYNC.REQUEST_NAME && syncFriendlyName && (
        <FeatureGate flagName={FEATURE_FLAGS.syncConfigRefreshMvp}>
          <ResyncToggle
            syncName={syncName}
            syncFriendlyName={syncFriendlyName}
            fileHostingType={formState?.fileHostingType?.value}
          />
        </FeatureGate>
      )}
    </>
  );
};

const SyncType = props => {
  const { syncName } = props;
  switch (syncName) {
    case CUSTOM_IDENTITY_SYNC.REQUEST_NAME:
      return <CustomIdentitySyncTable {...props} />;
    case BRING_YOUR_OWN_SYNCS[syncName]?.REQUEST_NAME:
      return (
        <BringYourOwnSyncFieldsTable
          {...props}
          requestInputName={BRING_YOUR_OWN_SYNCS[syncName].REQUEST_INPUT_NAME}
          dataFields={BRING_YOUR_OWN_SYNCS[syncName].FIELDS}
        />
      );
    default:
      return <IdentitySyncFieldsTable {...props} />;
  }
};

SyncType.propTypes = {
  syncName: pt.string.isRequired,
};

CardBody.propTypes = {
  fields: pt.array.isRequired,
  resetError: pt.func.isRequired,
  formState: pt.object.isRequired,
  setField: pt.func.isRequired,
  syncName: pt.string.isRequired,
  syncFriendlyName: pt.string,
  validateField: pt.func.isRequired,
  validateNumber: pt.func.isRequired,
  validateRequired: pt.func.isRequired,
};
export default CardBody;
